import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Compass, Star, Heart, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PublicNav } from '@/components/public/PublicNav';
import { Footer } from '@/components/public/Footer';

const ABOUT_IMG = 'https://images.pexels.com/photos/6476257/pexels-photo-6476257.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';

export default function About() {
  return (
    <div className="min-h-screen flex flex-col">
      <PublicNav />
      <section className="section-wash border-b border-border/60">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight">Quem Somos</h1>
          <p className="mt-3 text-muted-foreground max-w-2xl">Uma agência feita por quem ama viajar — e cuida de cada detalhe para você.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <img src={ABOUT_IMG} alt="Nossa equipe" className="w-full h-80 object-cover rounded-2xl card-shadow" />
          <div>
            <h2 className="font-display text-3xl font-semibold">Viajar é transformar</h2>
            <p className="mt-4 text-muted-foreground leading-relaxed">
              A Sandra Tur nasceu do desejo de tornar cada viagem simples, segura e memorável.
              Trabalhamos com fornecedores parceiros de confiança — como JMC, SOAR e FUJJITurismo — além de
              roteiros próprios cuidadosamente elaborados pela nossa equipe.
            </p>
            <p className="mt-4 text-muted-foreground leading-relaxed">
              Do primeiro contato ao retorno para casa, oferecemos um atendimento de concierge: entendemos
              o seu perfil, organizamos toda a logística e acompanhamos você em cada etapa.
            </p>
            <Button asChild className="mt-8" data-testid="about-cta">
              <Link to="/contato">Planejar minha viagem <ArrowRight className="ml-2 h-4 w-4" /></Link>
            </Button>
          </div>
        </div>
      </section>

      <section className="py-12 bg-card border-y border-border/60">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-6">
          {[
            { icon: Compass, t: 'Curadoria', d: 'Roteiros sob medida.' },
            { icon: ShieldCheck, t: 'Segurança', d: 'Parceiros confiáveis.' },
            { icon: Star, t: 'Experiência', d: 'Atendimento próximo.' },
            { icon: Heart, t: 'Cuidado', d: 'Cada detalhe importa.' },
          ].map((p, i) => (
            <div key={i} className="text-center">
              <span className="h-12 w-12 mx-auto rounded-xl bg-primary/10 text-primary flex items-center justify-center"><p.icon className="h-6 w-6" /></span>
              <h4 className="mt-3 font-semibold">{p.t}</h4>
              <p className="mt-1 text-sm text-muted-foreground">{p.d}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
